export default import.meta.ROLLDOWN_FILE_URL_paUmRy3bLCS9Viqg79ErlQ